import { enumPicMask } from "../constants";
import { XML_AddPair } from "./XML_AddPair";
import { XML_AddSingle } from "./XML_AddSingle";
import { XML_ScaleAndShiftX } from "./XML_ScaleAndShiftX";
import { XML_ScaleAndShiftY } from "./XML_ScaleAndShiftY";
import { XML_Param4 } from "./XML_Param4";
import { RoundTo3 } from "./RoundTo3";
import { XML_Scale } from "./XML_Scale.js";
import { XML_Param5 } from "./XML_Param5";

export function XML_DrawImagePPT(
  x,
  y,
  width,
  height,
  clipRect,
  mask,
  cell,
  drawElement,
  layer,
  linecolor,
  isIcon
) {
  var pDesc = cell.GetCellDesc().GetPicSourceInfo();

  x = XML_ScaleAndShiftX(x, drawElement, layer);
  y = XML_ScaleAndShiftY(y, drawElement, layer);
  width = XML_Scale(width, drawElement, layer);

  height = XML_Scale(height, drawElement, layer);

  if (mask === enumPicMask.grayscale) {
    XML_AddSingle("gray", "mask", drawElement);
  }

  if (isIcon) {
    XML_Param5(
      "icn",
      pDesc.fFileName,
      RoundTo3(x),
      RoundTo3(y),
      RoundTo3(width),
      RoundTo3(height),
      drawElement
    );
    return;
  }

  XML_Param4("im", RoundTo3(x), RoundTo3(y), RoundTo3(width), RoundTo3(height), drawElement);

  XML_AddSingle(pDesc.fFileName, "picfile", drawElement);
  XML_AddSingle(pDesc.fDirectory, "directory", drawElement);

  if (clipRect) {
    var clipleft = XML_ScaleAndShiftX(clipRect.fLeft, drawElement, layer);
    var clipright = XML_ScaleAndShiftX(clipRect.fRight, drawElement, layer);
    var cliptop = XML_ScaleAndShiftY(clipRect.fTop, drawElement, layer);
    var clipbottom = XML_ScaleAndShiftY(clipRect.fBottom, drawElement, layer);
    var clipWidth = clipright - clipleft;
    var clipHeight = clipbottom - cliptop;
    var trimX = (1 - width / clipWidth) / 2;
    XML_Param4("clp", RoundTo3(trimX), 0, RoundTo3(trimX), 0, drawElement);
  }
  if (mask === enumPicMask.circle) {
    XML_AddPair("cir", linecolor, "mask", drawElement);
  }
}
